import { createModel, RematchDispatch } from '@rematch/core';
import * as cmsWebRotateService from '../../services/cmsWebRotate.service';
import { checkWebRotateUsage } from '../../services/itemInfo.service';
import { PaginationType } from '../../types/CommonTypes';
import { WebRotateType } from '../../types/cmsWebRotate.type';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'webRotateEntity';

export const webRotateEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof webRotateEntity>) => ({
    async load(params): Promise<{ content?: WebRotateType[] } & PaginationType> {
      try {
        const res = await cmsWebRotateService.filter(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        if (!payload.id) {
          await cmsWebRotateService.create(payload);
        } else {
          await cmsWebRotateService.update(payload.id, payload);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(id) {
      try {
        const res = await cmsWebRotateService.deleteById(id);
        if (res && res.data) {
          this.remove({ id });
        }
        return res;
      } catch (e) {
        throw new Error(e);
      }
    },
    async checkUsage(code) {
      try {
        const { data } = await checkWebRotateUsage(code);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async findById(payload, state) {
      try {
        const item = state[storeName].ids[payload];
        if (item && !item.isSimplified) {
          return item;
        }
        const res = await cmsWebRotateService.getById(payload);
        this.update(res.data);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async publish(payload) {
      try {
        const { data: item } = await cmsWebRotateService.publish(payload);
        this.update(item);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default webRotateEntity;
